import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

const PageRoot = lazy(() => import('@app/components/PageRoot'));
const OrdersEmptyPage = lazy(() => import('.'));

class OrdersEmptyPageWebComponent extends ReactWebComponent {
    render() {
        return (
            <PageRoot>
                <OrdersEmptyPage />
            </PageRoot>
        );
    }
}

customElements.define('orders-empty-page', OrdersEmptyPageWebComponent);
